
import { routes as storeFront } from '@/views/StoreFront';
import { routes as auth } from '@/views/Auth';



export default [
  ...storeFront,
  ...auth,
];